const config = {
  BASE_PATH: "/api/v1/herupa",
};

export default config;
